export const BREAKDOWN_TYPES = ['Completed', 'Scheduled']
